import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BackArrow } from '../../../../components';
import { BodyDefault, HeadLine1 } from '../../../../components/typography/styled';
import { usePageTitle } from '../../../../context/navigationContext';
import { Container, Panel } from '../styles';

const OrderUnderReview: FC = () => {
  const [t] = useTranslation();
  usePageTitle(t('ORDER_UNDER_REVIEW'));

  return (
    <Container>
      <BackArrow fallbackPath='/orders' />
      <Panel>
        <HeadLine1>{t('ORDER_UNDER_REVIEW')}</HeadLine1>
        <BodyDefault style={{marginTop: '12px'}}>{t('ORDER_UNDER_REVIEW_TEXT')}</BodyDefault>
      </Panel>
    </Container>
  );
};

export default OrderUnderReview;
